/** @jsx h */

import Title, { titleId } from './Title'
import Answer from './Answer'
import ThankYou, { thankYouId } from './ThankYou'
import Skip from './Skip'
import { delay, hash } from './utils'
import { h, Component } from 'preact'
import { Wrapper, Inner, Outer, Background, Container } from './components'

class Question extends Component {
  constructor(props) {
    super()
    this.onSkip = this.onSkip.bind(this)
    this.onSelectAnswer = this.onSelectAnswer.bind(this)
    this.state = {
      eventHash: hash(props.event),
    }
  }
  componentDidMount() {
    const survey = document.getElementById(
      `scoops-${this.state.eventHash}-wrapper`
    )
    const offset = this.props.offset ? this.props.offset : 0
    const above = survey.clientHeight < this.props.targetY
    const isMobile = window.matchMedia('(max-width: 800px)')
    const skipOffset = isMobile.matches ? 70 : 0

    this.setState({
      rendered: true,
      surveyHeight: survey.clientHeight,
      surveyYOffset: offset
        ? survey.clientHeight * -1 - 20
        : above
          ? survey.clientHeight * -1 - 20 - skipOffset
          : this.props.targetHeight + 20,
    })
  }

  onSkip() {
    this.props.track('Clicked Skip', {})

    this.setState({
      removed: true,
    })

    return delay(300).then(() => {
      this.props.onRemove()
    })
  }

  onSelectAnswer(answer) {
    const selectedAnswer = document.getElementById(
      `scoops-${this.state.eventHash}-${answer.id}`
    )

    const totalAnswerHeight = this.props.question.answers.reduce(
      (aggregator, { id }) => {
        return (
          aggregator +
          document.getElementById(`scoops-${this.state.eventHash}-${id}`)
            .clientHeight +
          10
        )
      },
      0
    )

    const title = document.getElementById(titleId)
    const thankYou = document.getElementById(thankYouId)
    const answerIndex = this.props.question.answers.indexOf(answer)

    const answerHeight = selectedAnswer.clientHeight
    const titleHeight = title.clientHeight
    const thankYouHeight = thankYou.clientHeight

    const endSurveyHeight = answerHeight + thankYouHeight + 28
    const answerY = -answerIndex * (answerHeight + 10) - 19 - titleHeight
    const thanksY = -1 * (totalAnswerHeight - answerHeight + titleHeight)

    this.setState({
      selectedAnswerId: answer.id,
      removeSkip: true,
    })

    this.props.track('Clicked Survey Answer', {
      'Selected Answer': answer.text,
    })

    return delay(150 * this.props.question.answers.length).then(() => {
      this.setState({
        answered: true,
        endSurveyHeight,
        answerSpringY: answerY,
        thanksSpringY: thanksY,
        backgroundSpringY: this.state.surveyHeight - endSurveyHeight,
      })
      return delay(1500).then(() => {
        this.setState({
          removed: true,
        })

        return delay(300).then(() => {
          this.props.onRemove(answer)
        })
      })
    })
  }

  render(
    { align, question, theme, surveyWidth },
    {
      surveyYOffset,
      surveyHeight,
      endSurveyHeight,
      rendered,
      removed,
      selectedAnswerId,
      removeSkip,
      answered,
      thanksSpringY,
      answerSpringY,
      backgroundSpringY,
      eventHash,
    }
  ) {
    return (
      <Wrapper
        textFont={theme.textFont}
        textWeight={theme.textWeight}
        id={`scoops-${eventHash}-wrapper`}
        className={`${rendered ? 'in' : null} ${removed ? 'out' : null}`}
        style={{
          top: `${surveyYOffset}px`,
          [align]: `0px`,
          pointerEvents: rendered ? 'all' : 'none',
          maxWidth: `${surveyWidth}px`,
          minWidth: `${surveyWidth}px`,
        }}>
        <Container>
          {['top', 'bottom'].map(d => (
            <Background
              position={d}
              springToY={d === 'top' && backgroundSpringY}
              style={{
                height: `${surveyHeight / 2 + 10}px`,
              }}
              rendered={d === 'top' && rendered}
            />
          ))}
          <Outer
            height={answered ? endSurveyHeight : surveyHeight}
            shadowOffset={-backgroundSpringY}
            style={{
              height: surveyHeight,
              transform: `translateY(${backgroundSpringY}px)`,
            }}>
            <Title
              theme={theme}
              title={question.title}
              rendered={rendered}
              removed={selectedAnswerId}
            />
            <Inner className={rendered ? 'in' : null}>
              {question.answers.map((answer, i) => (
                <Answer
                  id={`scoops-${eventHash}-${answer.id}`}
                  key={answer.id}
                  answer={answer}
                  selected={answer.id === selectedAnswerId}
                  out={selectedAnswerId && answer.id !== selectedAnswerId}
                  outDelay={150 * (i - 1)}
                  springToY={answer.id === selectedAnswerId && answerSpringY}
                  onClick={() => this.onSelectAnswer(answer)}
                  theme={theme}>
                  {answer.text}
                </Answer>
              ))}
            </Inner>
            <ThankYou
              theme={theme}
              surveyWidth={surveyWidth}
              rendered={answered}
              springToY={thanksSpringY}
              message={question.feedBack}
            />
          </Outer>
        </Container>
        <Skip out={removeSkip} onClick={this.onSkip} theme={theme} />
      </Wrapper>
    )
  }
}

export default Question



// WEBPACK FOOTER //
// ../api/src/Question.jsx